import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static values = {
    selector: { type: String, default: "article[id]" }
  }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      {
        // Top 30% of viewport triggers intersection
        rootMargin: "-0% 0px -70% 0px",
        threshold: 0
      }
    )

    // Observe all sections matching the selector
    document.querySelectorAll(this.selectorValue).forEach((section) => {
      this.observer.observe(section)
    })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.setActive(entry.target.id)
      }
    })
  }

  setActive(id) {
    this.linkTargets.forEach((link) => {
      const isActive = link.getAttribute("href") === `#${id}`
      link.dataset.tocActive = isActive
    })
  }
}
